import {
    IYandexMetrikaInitParams,
    IYandexMetrikaParamsHandler,
    IYandexMetrikaReachGoalHandler,
} from './types';
import { YandexMetrikaService } from './service';
import { YandexMetrikaApi } from './api';

interface IYandexMetrikaService {
    reachGoal: IYandexMetrikaReachGoalHandler;
    params: IYandexMetrikaParamsHandler;
}

interface Params {
    metrikaInitParams: IYandexMetrikaInitParams;
    scriptSrc?: string;
}

export const createYandexMetrikaService = ({
    metrikaInitParams,
    scriptSrc,
}: Params): IYandexMetrikaService | null => {
    if (typeof window === 'undefined') {
        return null;
    }
    const metrikaApi = new YandexMetrikaApi({
        initialParams: metrikaInitParams,
        scriptSrc,
    });

    return new YandexMetrikaService({ metrikaApi });
};
